function isBuffer(value: unknown): boolean {
  if (value !== null && typeof value === 'object') {
    const constructor = (value as { constructor: unknown }).constructor;
    if (constructor != null && typeof (constructor as { isBuffer?: unknown }).isBuffer === 'function') {
      return (constructor as { isBuffer: (val: unknown) => boolean }).isBuffer(value);
    }
  }
  return false;
}

function keyIdentity(key: string) {
  return key;
}

export function flatten(target: any, opts?: any) {
  opts = opts || {};

  const delimiter = opts.delimiter || '.';
  const maxDepth = opts.maxDepth;
  const transformKey = opts.transformKey || keyIdentity;
  const output: { [key: string]: any } = {};

  function step(object: { [key: string]: any }, prev?: unknown, currentDepth?: number) {
    currentDepth = currentDepth || 1;
    Object.keys(object).forEach(function (key) {
      const value = object[key];
      const isarray = opts.safe && Array.isArray(value);
      const type = Object.prototype.toString.call(value);
      const isbuffer = isBuffer(value);
      const isobject = type === '[object Object]' || type === '[object Array]';

      const newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);

      if (
        !isarray &&
        !isbuffer &&
        isobject &&
        Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)
      ) {
        return step(value, newKey, currentDepth + 1);
      }

      output[newKey] = value;
    });
  }

  step(target);

  return output;
}

export function unflatten(target: any, opts?: any) {
  opts = opts || {};

  const delimiter = opts.delimiter || '.';
  const overwrite = opts.overwrite || false;
  const result: { [key: string]: any } = {};

  const isbuffer: boolean = isBuffer(target);
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target;
  }

  // safely ensure that the key is an integer.
  function getkey(key: string) {
    return isNaN(Number(key)) || key.indexOf('.') !== -1 || opts.object ? key : Number(key);
  }

  const sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length;
  });

  sortedKeys.forEach(function (key) {
    const split = key.split(delimiter);
    let key1 = getkey(split.shift() || "");
    let key2 = getkey(split[0]);
    let recipient = result;

    while (key2 !== undefined) {
      const type = Object.prototype.toString.call(recipient[key1]);
      const isobject = type === '[object Object]' || type === '[object Array]';

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return;
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = typeof key2 === 'number' && !opts.object ? [] : {};
      }

      recipient = recipient[key1];
      if (split.length > 0) {
        key1 = getkey(split.shift() || "");
        key2 = getkey(split[0]);
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts);
  });

  return result;
}
